















import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import MonthSelectorVue from "../../components/MonthSelector.vue";
import { DatePickerOptions } from "element-ui/types/date-picker";
@Component({
	...mapGetters(["accountBook"]),
	components: {
		"month-selector": MonthSelectorVue
	}
})
export default class VoucherCopy extends Vue {
	@Prop({ type: String })
	copyId!: string;
	@Prop({ type: Boolean, default: false })
	isRed!: boolean;
	yearValue: any = "";
	// 开始时间，用于禁用
	startTime: number = 0;
	// 截至时间，用于禁用
	endTime: number = 0;
	// 提示信息
	tips: string = "选中凭证将被复制的目标月份";
	mounted() {
		if (this.isRed) this.tips = "选中凭证将被红冲的目标月份"
		Vue.axios({
			url: `periods/${this.$store.state.accountBook.id}/findperiods`,
			method: "POST"
		}).then(res => {
			this.startTime = res.data.startTime;
			this.endTime = res.data.endTime;
		});
	}
	// 获取时间范围
	get pickerOptions(): DatePickerOptions {
		return {
			// disabledDate: time => {
			//   let start: number = <number>this.startTime;
			//   let end: number = <number>this.endTime;
			//   return time.getTime() < start || time.getTime() > end;
			// }
		};
	}
	close() {
		this.$emit("close", false);
	}
	confirmInput() {
		let time = this.$utils.simpleDateFormat(this.yearValue, "m");
		if (this.isRed) {
			Vue.axios
				.post(`vouchers/repair?idStr=${this.copyId}&period=${time}`, { nothing: 1 })
				.then((res) => {
					this.$emit("reset");
					this.$notify({
						title: "温馨提示",
						message: "红冲成功",
						type: "success"
					});
					// this.fetchData();
				});
		} else {
			Vue.axios
				.post(
					`vouchers/copy?accountBookId=${this.$store.state.accountBook.id}&idStr=${this.copyId}&period=${time}`,
					{ nothing: 1 }
				)
				.then(res => {
					this.$message.warning(res.data.message);
					(this.yearValue = ""), this.$emit("close", true, time);
				});
		}
	}
}
